<template>
    <div>
        <v-card>
            <v-toolbar dark flat color="secondary">
                <v-toolbar-title @click="showCard=!showCard" :style="$store.state.textFormatting.headers">
                    {{this.$store.state.user.username}}: {{$store.state.user.user_type}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <info>
                  <template slot>
                      User information
                  </template>
                  <template slot="body">
                      All registered user information and last time of login.
                  </template>
                  <template slot="action">
                      <v-btn flat color="primary" to="/userAdmin" :style="$store.state.textFormatting.main"> Edit User</v-btn>
                  </template>
                </info>
            </v-toolbar>
            <v-card-text v-if="showCard" :style="$store.state.textFormatting.main">
                <v-layout row wrap align-start justify-start>
                    <v-flex xs6>
                        <h4 > Name: {{$store.state.user.given_name}} {{$store.state.user.family_name}} </h4>
                    </v-flex>
                    <v-flex xs6>
                        <h4 > Organisation: {{$store.state.user.organisation}} </h4>
                    </v-flex>
                    <v-flex>
                        <h4 > Email Address: {{$store.state.user.email}}</h4>
                    </v-flex>
                    <v-flex>
                        <h4 > Login Date/Time: {{login_time}}</h4>
                    </v-flex>
                </v-layout> 
            </v-card-text>
        </v-card>
    </div>
</template>

<script>

import info from './infopopout.vue'

export default {
    name: 'userinfo',
    components: {
        info
    },
    data () {
        return {
            userinfo1: [],
            userinfo2: [],
            orginfo: [],
            login_time: Date(this.$store.state.user.login_time *1000).substr(0,25),
            showCard: true

        }
    },
}
</script>

